import { useMountEffect } from "@react-hookz/web";
import parser, { Element } from "html-react-parser";
import React, { useMemo } from "react";
import { CloseButton } from "~/components/acquisition-popup-container/display/popups/common/close-button";
import { PopupBackdrop } from "~/components/acquisition-popup-container/display/styles";
import { useSdkContext } from "~/components/contexts";
import { Modal } from "~/components/modal";
var CheckedIcon = function CheckedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 28C0 12.536 12.536 0 28 0s28 12.536 28 28-12.536 28-28 28S0 43.464 0 28Z",
    fill: "#FFCA05"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m13.684 30.853 10.724 10.725 17.841-17.84a2.333 2.333 0 1 0-3.3-3.3l-14.54 14.54-7.425-7.424a2.333 2.333 0 1 0-3.3 3.3Z",
    fill: "#001246"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .346)",
    d: "M0 0h56v56H0z"
  }))));
};
CheckedIcon.defaultProps = {
  width: "56",
  height: "57",
  viewBox: "0 0 56 57",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import { Container, ContentContainer, Description, DownloadLink, StyledRedirectButton, Title } from "./styles";
export const MyNewsCompletionPopup = ({
  config,
  modalContainerReference,
  onClose
}) => {
  const {
    currentRoute,
    handleTrackGA
  } = useSdkContext();
  const isMyNewsIndexPage = currentRoute.toLowerCase() === "mynews";
  const gaEventPrefix = useMemo(() => isMyNewsIndexPage ? "My News/Index" : "My News", [isMyNewsIndexPage]);
  useMountEffect(() => {
    handleTrackGA({
      action: `${gaEventPrefix}/CompletionPopup/Impression`,
      category: "My News",
      label: isMyNewsIndexPage ? "" : window.location.href
    });
  });
  const computedButtonText = () => isMyNewsIndexPage ? config.button.inMyNewsText : config.button.otherPageText;
  return /*#__PURE__*/React.createElement(Modal, {
    BackdropComponent: PopupBackdrop,
    container: modalContainerReference === null || modalContainerReference === void 0 ? void 0 : modalContainerReference.current,
    fadeTimeout: 400,
    open: true,
    "data-qa": "my-news-completion-popup"
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(CloseButton, {
    onClose: () => {
      handleTrackGA({
        action: `${gaEventPrefix}/CompletionPopup/Close`,
        category: "My News",
        label: ""
      });
      onClose();
    }
  }), /*#__PURE__*/React.createElement(ContentContainer, null, /*#__PURE__*/React.createElement(CheckedIcon, null), /*#__PURE__*/React.createElement(Title, {
    dangerouslySetInnerHTML: {
      __html: config.headline
    }
  }), /*#__PURE__*/React.createElement(Description, null, parser(config.description, {
    replace: domNode => {
      if (domNode instanceof Element && domNode.name === "download-link") {
        return /*#__PURE__*/React.createElement(DownloadLink, {
          onClick: () => {
            handleTrackGA({
              action: `${gaEventPrefix}/CompletionPopup/Download`,
              category: "My News",
              label: ""
            });
            window.open("https://scmp.onelink.me/3586748601/aalocqf2", "_blank");
          }
        }, "download");
      }
      return domNode;
    }
  })), /*#__PURE__*/React.createElement(StyledRedirectButton, {
    dangerouslySetInnerHTML: {
      __html: computedButtonText()
    },
    url: "/mynews",
    onClick: () => {
      handleTrackGA({
        action: `${gaEventPrefix}/CompletionPopup/Click`,
        category: "My News",
        label: ""
      });
      onClose();
    }
  }))));
};
MyNewsCompletionPopup.displayName = "MyNewsCompletionPopup";